import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Shield, ArrowRight, Heart } from 'lucide-react';
import { useAppContext } from '../contexts/AppContext';
import { toast } from 'sonner';
import { BillvastLogo } from '../components/ui/BillvastLogo';
export const Login: React.FC = () => {
  const [email, setEmail] = useState('demo@billvast.com');
  const [password, setPassword] = useState('password123');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {
    login
  } = useAppContext();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      login();
      toast.success('Welcome back to Billvast!');
      navigate('/dashboard');
    }, 1000);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-1194">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1195">
        <div className="flex justify-center" data-id="element-1196">
          <BillvastLogo size="xl" data-id="element-1197" />
        </div>
        <p className="mt-4 text-center text-sm text-brand-text-light" data-id="element-1198">
          Powering Africa's Digital Economy
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1199">
        <div className="bg-white py-8 px-4 shadow-xl shadow-gray-200/50 sm:rounded-2xl sm:px-10 border border-gray-100" data-id="element-1200">
          <form className="space-y-6" onSubmit={handleLogin} data-id="element-1201">
            <div data-id="element-1202">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-1203">
                Email address
              </label>
              <div className="mt-1" data-id="element-1204">
                <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-1205" />
              </div>
            </div>

            <div data-id="element-1206">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-1207">
                Password
              </label>
              <div className="mt-1" data-id="element-1208">
                <input id="password" name="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-1209" />
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-1210">
              <div className="flex items-center" data-id="element-1211">
                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-brand-primary focus:ring-brand-primary border-gray-300 rounded" data-id="element-1212" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-1213">
                  Remember me
                </label>
              </div>

              <div className="text-sm" data-id="element-1214">
                <a href="#" className="font-medium text-brand-primary hover:text-brand-primary-dark" data-id="element-1215">
                  Forgot your password?
                </a>
              </div>
            </div>

            <div data-id="element-1216">
              <button type="submit" disabled={isLoading} className="w-full flex justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-medium text-white bg-brand-primary hover:bg-brand-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary transition-colors disabled:opacity-70" data-id="element-1217">
                {isLoading ? 'Signing in...' : 'Sign in'}
              </button>
            </div>
          </form>

          <div className="mt-6" data-id="element-1218">
            <div className="relative" data-id="element-1219">
              <div className="absolute inset-0 flex items-center" data-id="element-1220">
                <div className="w-full border-t border-gray-300" data-id="element-1221" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1222">
                <span className="px-2 bg-white text-gray-500" data-id="element-1223">Demo Access</span>
              </div>
            </div>

            <div className="mt-6" data-id="element-1224">
              <button onClick={handleLogin} className="w-full inline-flex justify-center items-center gap-2 py-3 px-4 border border-gray-300 rounded-xl shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors mb-3" data-id="element-1225">
                <Shield size={18} className="text-brand-primary" data-id="element-1226" />
                Continue as Demo User
                <ArrowRight size={16} className="text-gray-400 ml-auto" data-id="element-1227" />
              </button>

              <Link to="/donate" className="w-full inline-flex justify-center items-center gap-2 py-3 px-4 border border-brand-primary/30 rounded-xl shadow-sm bg-brand-primary/5 text-sm font-medium text-brand-primary-dark hover:bg-brand-primary/10 transition-colors" data-id="element-1228">
                <Heart size={18} className="text-brand-primary" data-id="element-1229" />
                Donate as Guest
                <ArrowRight size={16} className="text-brand-primary/50 ml-auto" data-id="element-1230" />
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center" data-id="element-1231">
          <p className="text-sm text-gray-600" data-id="element-1232">
            Don't have an account?{' '}
            <Link to="/signup" className="font-medium text-brand-primary hover:text-brand-primary-dark" data-id="element-1233">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>;
};